import { useRouteError } from '@modern-js/runtime/router';
import { SuspensePage } from '@packages/common/components/SuspensePage/SuspensePage';
import { useEffect } from 'react';
import { lazily } from 'react-lazily';
import { setAppIsLoading } from 'utils/appLoadingHandler';
const { GlobalUnexpectedError } = lazily(
	() =>
		import('components/pages/GlobalUnexpectedError/GlobalUnexpectedError'),
);
export const ErrorBoundary = () => {
	// @ts-ignore
	const _error = useRouteError() as { status: string; message: string };
	useEffect(() => {
		setAppIsLoading(false);
	}, []);
	return (
		<SuspensePage>
			<GlobalUnexpectedError />
		</SuspensePage>
	);
};
export default ErrorBoundary;
